import Component from 'antd/es/tooltip';
import 'antd/lib/tooltip/style';
export default Component;

